/**
 * 로그인 후 리다이렉트 관리 유틸리티
 */

const REDIRECT_KEY = 'login_redirect_path';

/**
 * 현재 경로를 저장합니다 (로그인 후 돌아갈 경로)
 * @param path 저장할 경로 (없으면 현재 경로 사용)
 */
export const saveRedirectPath = (path?: string): void => {
  const redirectPath = path || window.location.pathname + window.location.search;
  
  // 로그인/회원가입 관련 페이지는 저장하지 않음
  const excludedPaths = ['/login', '/signup', '/forgot-password'];
  const shouldExclude = excludedPaths.some(excluded => redirectPath.startsWith(excluded));
  
  if (!shouldExclude) {
    sessionStorage.setItem(REDIRECT_KEY, redirectPath);
    /// console.log('리다이렉트 경로 저장:', redirectPath);
  }
};

/**
 * 저장된 리다이렉트 경로를 가져옵니다
 * @returns 저장된 경로 또는 null
 */
export const getRedirectPath = (): string | null => {
  return sessionStorage.getItem(REDIRECT_KEY);
};

/**
 * 저장된 리다이렉트 경로를 제거합니다
 */
export const clearRedirectPath = (): void => {
  sessionStorage.removeItem(REDIRECT_KEY);
};

/**
 * 로그인 후 적절한 경로로 이동합니다
 * @param navigate React Router의 navigate 함수
 * @param fallbackPath 기본 경로 (기본값: '/')
 */
export const redirectAfterLogin = (navigate: (path: string, options?: any) => void, fallbackPath: string = '/'): void => {
  const redirectPath = getRedirectPath();
  
  if (redirectPath) {
    /// console.log('저장된 경로로 리다이렉트:', redirectPath);
    clearRedirectPath();
    navigate(redirectPath, { replace: true });
  } else {
    /// console.log('기본 경로로 리다이렉트:', fallbackPath);
    navigate(fallbackPath, { replace: true });
  }
};

/**
 * 로그인이 필요한 액션을 수행하기 전에 현재 경로를 저장합니다
 * 주로 버튼 클릭 이벤트에서 사용
 */
export const handleRequireLogin = (onLoginRequired: () => void): void => {
  saveRedirectPath();
  onLoginRequired();
};
